<!--
  MapOSMOL.vue
    OpenStreetMap OpenLayers Component
-->

<!-- -------------------------------------------------------------------------------- -->
<!--
<style src="../lib/openlayers/ol.css"></style>
-->
<template>
  <div>
    <div :id="this.pmapid" class="hm-map-style"></div>
  </div>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import 'ol/ol.css'
import { Map, View, Feature } from 'ol'
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer'
import { OSM, Vector as VectorSource } from 'ol/source'
import Point from 'ol/geom/Point'
import { fromLonLat } from 'ol/proj'
import { Style, Icon } from 'ol/style'
import { isNullorUndefined } from '@/common'

// @Todo 初回表示の地図の中心を検討する
const initLL = [139.620725, 35.594141]
const MARKER_IMG_SRC = 'https://' + process.env.IMG_SERVER_ADDR + '/marker-32.png'

export default {
  name: 'MapOSMOL',
  props: [ 'pmapid' ],
  data: () => ({
    mMap: undefined,
    mZoom: 10,
    mMaxZoom: 17,   // マーカー表示時のZoom倍率
    mMinZoom: 5,
    mCenter: initLL,
    mVectorLayer: undefined,
    mVectorSource: undefined,
    mLon: '-',
    mLat: '-',
    mMarkerList: [],
  }),
  mounted: function () {
    this.$log.debug('# MapOSMOL ' + this.pmapid)
    this.$on('renderMap', this.renderMap)
    //this.mVectorSource = new ol.source.Vector({ features: [] })
    this.mVectorSource = new VectorSource({ features: [] })
    //this.mVectorLayer = new ol.layer.Vector({
    this.mVectorLayer = new VectorLayer({
      source: this.mVectorSource
    })
    //this.renderMap()
  },
  destroyed: function () {
    this.$log.debug('# MapOSMOL')
  },
  methods: {
    // -------------------------------------------------------------------------
    // 地図にマーカを描画する
    //
    // @remark staff_id allows null
    setMarker: function (zoom, lon, lat, staff_id) {
      let ll = [lon, lat]
      this.mLon = ll[0].toString()
      this.mLat = ll[1].toString()
      //let pos = new ol.Feature({
      let pos = new Feature({
        //geometry: new ol.geom.Point(ol.proj.transform([lon, lat], "EPSG:4326", "EPSG:900913"))
        //geometry: new ol.geom.Point(ol.proj.fromLonLat([lon, lat]))
        geometry: new Point(fromLonLat([lon, lat]))
      })

      //pos.setStyle(new ol.style.Style({
      pos.setStyle(new Style({
        image: new Icon(/** @type {olx.style.IconOptions} */ {
          anchor: [0.5, 1],
          opacity: 0.75,
          // @Todo ローカルで画像ファイルを参照したいが、なぜか表示されない
          //src: '../assets/marker-32.png'
          src: MARKER_IMG_SRC,
        })
      }))

      this.mVectorSource.addFeature(pos)
      const extent = this.mVectorSource.getExtent()
      this.mMap.getView().fit(extent, {size: this.mMap.getSize(), maxZoom: zoom})

      if (!isNullorUndefined(staff_id)) {
        this.mMarkerList.push(
          { id: staff_id, marker: pos }
        )
      }
    },
    // -------------------------------------------------------------------------
    removeMarker: function (staff_id) {
      if (!isNullorUndefined(staff_id)) {
        let target = this.mMarkerList.find((elm) => {
          return (elm.id === staff_id)
        })
        if (!isNullorUndefined(target)) {
          this.mVectorSource.removeFeature(target.marker)
          this.mMarkerList.splice(this.mMarkerList.indexOf(target), 1)
          if (this.mMarkerList.length !== 0) {
            const extent = this.mVectorSource.getExtent()
            this.mMap.getView().fit(extent, {size: this.mMap.getSize(), maxZoom: this.mMaxZoom})
          }
        }
      }
    },
    // -------------------------------------------------------------------------
    hasMarker: function (staff_id) {
      let target = this.mMarkerList.find((elm) => {
        return (elm.id === staff_id)
      })
      return !isNullorUndefined(target)
    },
    // -------------------------------------------------------------------------
    clearMarker: function (staff_id) {
      this.mVectorSource.clear()
      this.mMarkerList = []
    },
    // -------------------------------------------------------------------------
    // 地図を描画する
    renderMap: function () {
      this.$log.debug('render map ' + this.pmapid)
      //this.mMap = new ol.Map({
      this.mMap = new Map({
        target: this.pmapid,
        layers: [
          //new ol.layer.Tile({
          new TileLayer({
            //source: new ol.source.OSM()
            source: new OSM()
          }),
          this.mVectorLayer
        ],
        //view: new ol.View({
        view: new View({
          //projection: 'EPSG:4326',
          //center: ol.proj.fromLonLat(this.mCenter),
          center: fromLonLat(this.mCenter),
          zoom: this.mZoom,
        })
      })
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-map-style {
  margin: 0px auto;
  height: 100%;
  width: 100%;
  /*border: solid 1px #b22222;*/
}
/*
#hm-map2 {
  margin: 0px auto;
  margin-top: 10px;
  height: 40vh;
  width: 95%;
}
*/
</style>



// WEBPACK FOOTER //
// src/components/MapOSMOL.vue